"use strict";

var _interopRequireDefault = require("D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Assemblystatus = Assemblystatus;
exports.Batchtype = Batchtype;
exports.Batchtypes = Batchtypes;
exports.Boxnumber = Boxnumber;
exports.ComplainClassify = ComplainClassify;
exports.ComplainType = ComplainType;
exports.CostCenter = CostCenter;
exports.Customercode = Customercode;
exports.DeliveryType = DeliveryType;
exports.FUnits = FUnits;
exports.Factorytype = Factorytype;
exports.GetBdtaCity = GetBdtaCity;
exports.GetBdtaProvince = GetBdtaProvince;
exports.GoodsType = GoodsType;
exports.GroupTypes = GroupTypes;
exports.Handoverstatus = Handoverstatus;
exports.Humantasks = Humantasks;
exports.Inspectiontype = Inspectiontype;
exports.Inventoryscheduling = Inventoryscheduling;
exports.Inventorystatus = Inventorystatus;
exports.ItemSort = ItemSort;
exports.Logos = Logos;
exports.Maintenances = Maintenances;
exports.Maintenancestatus = Maintenancestatus;
exports.Medium = Medium;
exports.OriginDestinationAbbreviation = OriginDestinationAbbreviation;
exports.Outboundstatus = Outboundstatus;
exports.Outboundtype = Outboundtype;
exports.PickingingStatu = PickingingStatu;
exports.Pickingstatus = Pickingstatus;
exports.Prioritylevel = Prioritylevel;
exports.Qualityinspection = Qualityinspection;
exports.QueryCustomerNameCodeList = QueryCustomerNameCodeList;
exports.Routinecheckstatus = Routinecheckstatus;
exports.SendingStatus = SendingStatus;
exports.Testingtools = Testingtools;
exports.Transaction = Transaction;
exports.TransportMethod = TransportMethod;
exports.TransportState = TransportState;
exports.TransportStatewx = TransportStatewx;
exports.TsSettlementMethod = TsSettlementMethod;
exports.WorkOrderTypes = WorkOrderTypes;
exports.Workordertype = Workordertype;
exports.Workordertypevue = Workordertypevue;
exports.YCYYFL = YCYYFL;
exports.aRecodeType = aRecodeType;
exports.abnormalsource = abnormalsource;
exports.abnormalsourcest = abnormalsourcest;
exports.accessories = accessories;
exports.arrivalstatus = arrivalstatus;
exports.auditstatus = auditstatus;
exports.badcodetype = badcodetype;
exports.cangwei = cangwei;
exports.checkidentification = checkidentification;
exports.cities = cities;
exports.classgroup = classgroup;
exports.classification = classification;
exports.corporatename = corporatename;
exports.cpleixin = cpleixin;
exports.cyclecounting = cyclecounting;
exports.department = department;
exports.emailstatus = emailstatus;
exports.equipment = equipment;
exports.equipmentstatus = equipmentstatus;
exports.formForm = formForm;
exports.formatkey = formatkey;
exports.getAreaName = getAreaName;
exports.getAssyMode = getAssyMode;
exports.getCustItemType = getCustItemType;
exports.getCustomer = getCustomer;
exports.getDataInterface = getDataInterface;
exports.getEntityItem = getEntityItem;
exports.getEqpKey = getEqpKey;
exports.getEquipmentCode = getEquipmentCode;
exports.getEquipmentGroup = getEquipmentGroup;
exports.getEquipmentGroupOwner = getEquipmentGroupOwner;
exports.getEquipmentProperties = getEquipmentProperties;
exports.getEquipmentStatusChangeCode = getEquipmentStatusChangeCode;
exports.getEquipmentType = getEquipmentType;
exports.getFactory = getFactory;
exports.getFactoryType = getFactoryType;
exports.getFileName = getFileName;
exports.getFlowKey = getFlowKey;
exports.getFlowKeyDataInterface = getFlowKeyDataInterface;
exports.getFlowType = getFlowType;
exports.getForkliftTaskType = getForkliftTaskType;
exports.getGroup = getGroup;
exports.getHoldHandleKey = getHoldHandleKey;
exports.getHoldKey = getHoldKey;
exports.getHoldRelKey = getHoldRelKey;
exports.getInType = getInType;
exports.getInventoryState = getInventoryState;
exports.getItemFg = getItemFg;
exports.getItemFgg = getItemFgg;
exports.getItemGroup = getItemGroup;
exports.getItemMtl = getItemMtl;
exports.getItemType = getItemType;
exports.getLine = getLine;
exports.getMaterial = getMaterial;
exports.getMtlControl = getMtlControl;
exports.getNameOfSuperiorEquipment = getNameOfSuperiorEquipment;
exports.getOrderKey = getOrderKey;
exports.getOsiTimePlan = getOsiTimePlan;
exports.getOutInStockType = getOutInStockType;
exports.getOutType = getOutType;
exports.getPmKind = getPmKind;
exports.getRuleFormat = getRuleFormat;
exports.getRuleType = getRuleType;
exports.getRunCardTemp = getRunCardTemp;
exports.getSonMaterial = getSonMaterial;
exports.getStatus = getStatus;
exports.getStepKey = getStepKey;
exports.getStepMenu = getStepMenu;
exports.getStepSelector = getStepSelector;
exports.getStepType = getStepType;
exports.getStoreRoom = getStoreRoom;
exports.getStoreSite = getStoreSite;
exports.getStrWoKey = exports.getStrOrderKey = exports.getStrItemMtl = exports.getStrItemFg = exports.getStrEqpKey = exports.getStrEntityItem = exports.getStrCustomer = void 0;
exports.getTempKey = getTempKey;
exports.getTempType = getTempType;
exports.getTypeOfMachine = getTypeOfMachine;
exports.getUnScrapKey = getUnScrapKey;
exports.getUnitKey = getUnitKey;
exports.getUser = getUser;
exports.getVender = getVender;
exports.getVendorType = getVendorType;
exports.getWipLabel = getWipLabel;
exports.getWmsItemType = getWmsItemType;
exports.getWoKey = getWoKey;
exports.getWoStatus = getWoStatus;
exports.getWorkShop = getWorkShop;
exports.getcorporatename = getcorporatename;
exports.getgoods = getgoods;
exports.getindocumenttype = getindocumenttype;
exports.getoutdocumenttype = getoutdocumenttype;
exports.getparentNameMtl = getparentNameMtl;
exports.getshiftKey = getshiftKey;
exports.getwarehouseorganization = getwarehouseorganization;
exports.grouppriority = grouppriority;
exports.handlingmethod = handlingmethod;
exports.handlingmethodpda = handlingmethodpda;
exports.hoursstatus = hoursstatus;
exports.inspection = inspection;
exports.inspectionstatus = inspectionstatus;
exports.kekuwei = kekuwei;
exports.kuwei = kuwei;
exports.linename = linename;
exports.listingstatus = listingstatus;
exports.locationidentification = locationidentification;
exports.lockingstate = lockingstate;
exports.maintenancestatus = maintenancestatus;
exports.manufacturer = manufacturer;
exports.materiall = materiall;
exports.materialrack = materialrack;
exports.migrationtask = migrationtask;
exports.navstast = navstast;
exports.nonconformity = nonconformity;
exports.occupancystatus = occupancystatus;
exports.ordertype = ordertype;
exports.ordertypeves = ordertypeves;
exports.packagingarea = packagingarea;
exports.personnel = personnel;
exports.personnelall = personnelall;
exports.pickingmethod = pickingmethod;
exports.pickingstatus = pickingstatus;
exports.pickingtype = pickingtype;
exports.printform = printform;
exports.procedure = procedure;
exports.processingstatus = processingstatus;
exports.productversion = productversion;
exports.provinceAll = provinceAll;
exports.rackclassification = rackclassification;
exports.rackclassifications = rackclassifications;
exports.receipttype = receipttype;
exports.receivingstatus = receivingstatus;
exports.reservoirarea = reservoirarea;
exports.reviewstatus = reviewstatus;
exports.schedulingstatus = schedulingstatus;
exports.setstatus = setstatus;
exports.specialremarks = specialremarks;
exports.specifications = specifications;
exports.storagearea = storagearea;
exports.storeroom = storeroom;
exports.supplierpost = supplierpost;
exports.taskstatus = taskstatus;
exports.tasktype = tasktype;
exports.transferstatus = transferstatus;
exports.transfertype = transfertype;
exports.typesof = typesof;
exports.uploadstatus = uploadstatus;
exports.warehouselo = warehouselo;
exports.warehousestatus = warehousestatus;
exports.warehousingmethod = warehousingmethod;
exports.workmanship = workmanship;
exports.yanmo = yanmo;
exports.zhixing = zhixing;
var _request = _interopRequireDefault(require("@/utils/request"));
//  /api/system/DataInterface/${id}/Actions/Response  --数据源
// /api/system/DictionaryData/${id}/Data/Selector  --数据字典

//采埃孚
// //收货状态
// export function receivingstatus() {
//   return request({
//     url: `/api/system/DictionaryData/450519495849542917/Data/Selector`,
//     method: "GET"
//   });
// 工艺

//市
function cities(query) {
  return (0, _request.default)({
    url: "api/BasicData/CustomerUser/cities/".concat(query),
    method: 'get'
  });
}
//省
function provinceAll() {
  return (0, _request.default)({
    url: "api/BasicData/CustomerUser/all",
    method: 'get'
  });
}
//省wx
function GetBdtaProvince() {
  return (0, _request.default)({
    url: "api/TMS/calculatecostsrule/GetBdtaProvince",
    method: 'get'
  });
}
//市wx
function GetBdtaCity(row) {
  return (0, _request.default)({
    url: "api/TMS/calculatecostsrule/GetBdtaCity",
    method: 'get',
    data: {
      province: row
    }
  });
}

//客户名称
function QueryCustomerNameCodeList(query) {
  return (0, _request.default)({
    url: "api/BasicData/CustomerUser/QueryCustomerNameCodeList",
    method: 'post',
    data: {
      currentPage: 1,
      pageSize: 50000
    }
  });
}

//运输状态
function TransportStatewx() {
  return (0, _request.default)({
    url: "/api/BasicData/WeChat/GetTransportState",
    method: "GET"
  });
}
//成本中心
function CostCenter() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/CostCenter/Data/Selector",
    method: "GET"
  });
}
//始发地目的地简称
function OriginDestinationAbbreviation() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/OriginDestinationAbbreviation/Data/Selector",
    method: "GET"
  });
}
//运输状态wx
function TransportState() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/TransportState/Data/Selector",
    method: "GET"
  });
}
//延迟原因分类
function YCYYFL() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/YCYYFL/Data/Selector",
    method: "GET"
  });
}

//消息发送状态
function SendingStatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/SendingStatus/Data/Selector",
    method: "GET"
  });
}

//运输方式
function TransportMethod() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/TransportMethod/Data/Selector",
    method: "GET"
  });
}
//运输结算方式
function TsSettlementMethod() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/TsSettlementMethod/Data/Selector",
    method: "GET"
  });
}
//投诉类型
function ComplainType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/ComplainType/Data/Selector",
    method: "GET"
  });
}
//投诉分类
function ComplainClassify() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/ComplainClassify/Data/Selector",
    method: "GET"
  });
}
//发货类型
function DeliveryType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/DeliveryType/Data/Selector",
    method: "GET"
  });
}
//货物类型
function GoodsType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/GoodsType/Data/Selector",
    method: "GET"
  });
}
function workmanship() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/542177801810216197/Data/Selector",
    method: "GET"
  });
}
// 拣选状态
function GroupTypes() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/517171114489677061/Data/Selector",
    method: "GET"
  });
}
// 拣选状态
function PickingingStatu() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/487538264924751109/Data/Selector",
    method: "GET"
  });
}
// 拣货类型
function pickingtype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/458491920230909189/Data/Selector",
    method: "GET"
  });
}

// 订单类型
function ordertypeves() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/520389711731098885/Data/Selector",
    method: "GET"
  });
}
// 特殊备注
function specialremarks() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/517199738995475717/Data/Selector",
    method: "GET"
  });
}
// 移库状态
function transferstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/507338141003154693/Data/Selector",
    method: "GET"
  });
}
// 移库类型
function transfertype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/507328120353719557/Data/Selector",
    method: "GET"
  });
}
// 处理状态（移库任务）
function migrationtask() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/507338141003154693/Data/Selector",
    method: "GET"
  });
}
// NAV入库状态
function navstast() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/507362165817083141/Data/Selector",
    method: "GET"
  });
}
// 优先级
function grouppriority() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/463207472354559237/Data/Selector",
    method: "GET"
  });
}
// 产线名称
function linename() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/463587188005668101/Actions/Response",
    method: "GET"
  });
}
// 质检状态
function inspectionstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/504795465426928901/Data/Selector",
    method: "GET"
  });
}
// }
// 处理状态
function processingstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/504549153364247813/Data/Selector",
    method: "GET"
  });
}
// 异常分类
function abnormalsourcest() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/505282840842208517/Data/Selector",
    method: "GET"
  });
}
// 异常来源/异常分类
function abnormalsource() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/504072587471488261/Data/Selector",
    method: "GET"
  });
}

// 储存分类
function ItemSort() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/489657442813084933/Data/Selector",
    method: "GET"
  });
}
// 占用状态
function occupancystatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/486042605453313285/Data/Selector",
    method: "GET"
  });
}
//库位
function warehouselo() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/349806175555945733/Actions/Response",
    method: "GET"
  });
}
// 审核状态
function auditstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/476545482999465221/Data/Selector",
    method: "GET"
  });
}
// 锁定状态
function lockingstate() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/476190442191324421/Data/Selector",
    method: "GET"
  });
}
// 循环盘点方式
function reviewstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/475189132704875781/Data/Selector",
    method: "GET"
  });
}
// 循环盘点方式
function cyclecounting() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/473713764500243717/Data/Selector",
    method: "GET"
  });
}
// 工单质检结果
function inspection() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/469770863504262405/Data/Selector",
    method: "GET"
  });
}
// 检测工具
function Testingtools() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/469764902655886597/Data/Selector",
    method: "GET"
  });
}
// 盘点状态
function Inventorystatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/471208579202811141/Data/Selector",
    method: "GET"
  });
}
// 抽盘标识
function checkidentification() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/471819320381408517/Data/Selector",
    method: "GET"
  });
}
// 上传状态
function uploadstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/469400460898338053/Data/Selector",
    method: "GET"
  });
}
// 工单类型
function Workordertypevue() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/463569859414852869/Data/Selector",
    method: "GET"
  });
}
//组装状态
function Assemblystatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/463569859414852869/Data/Selector",
    method: "GET"
  });
}
//质检要求
function Qualityinspection() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/463575982347912453/Data/Selector",
    method: "GET"
  });
}
//工单类型
function WorkOrderTypes() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/463574674639422725/Data/Selector",
    method: "GET"
  });
}
//库位标识
function locationidentification() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/464209538979988741/Data/Selector",
    method: "GET"
  });
}
//人员管理任务类型
function Humantasks() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/463239368341980421/Data/Selector",
    method: "GET"
  });
}
//入库排班状态
function Inventoryscheduling() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/462032629483439365/Data/Selector",
    method: "GET"
  });
}
//交接状态
function Handoverstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/461010121338651909/Data/Selector",
    method: "GET"
  });
}
//优先级别
function Prioritylevel() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/453004081728849157/Data/Selector",
    method: "GET"
  });
}
//领料状态
function Pickingstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/460654807162553605/Data/Selector",
    method: "GET"
  });
}
//出库类型
function Outboundtype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/460654437992498437/Data/Selector",
    method: "GET"
  });
}
//出库状态
function Outboundstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/460698338547729669/Data/Selector",
    method: "GET"
  });
}
//打印状态
function printform() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/460669894837404933/Data/Selector",
    method: "GET"
  });
}
//工时状态
function hoursstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/456293481455813893/Data/Selector",
    method: "GET"
  });
}

//任务类型

function tasktype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/458491920230909189/Data/Selector",
    method: "GET"
  });
}
//拣货方式
function pickingmethod() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/458498199661839621/Data/Selector",
    method: "GET"
  });
}
//拣货状态
function pickingstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/459557472550520069/Data/Selector",
    method: "GET"
  });
}
//到货状态
function arrivalstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/457021218030093573/Data/Selector",
    method: "GET"
  });
}
//设置状态
function setstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/456329909036385541/Data/Selector",
    method: "GET"
  });
}
//上架任务状态
function taskstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/458828782824850693/Data/Selector",
    method: "GET"
  });
}
//排班状态
function schedulingstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/456981170488345861/Data/Selector",
    method: "GET"
  });
}
//公司名称
function corporatename() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/454116638933910789/Data/Selector",
    method: "GET"
  });
}
//打包区
function packagingarea() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/458428641106199813/Data/Selector",
    method: "GET"
  });
}
//处理方式pda
function handlingmethodpda() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/469767786600596741?keyword=&isTree=0  ",
    method: "GET"
  });
}
//处理方式
function handlingmethod() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/455534404060579077/Data/Selector",
    method: "GET"
  });
}
//不合格原因
function nonconformity() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/455526972970239237/Data/Selector",
    method: "GET"
  });
}
//库区
function reservoirarea() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/454131302354912517/Actions/Response",
    method: "GET"
  });
}
//供应商
function supplierpost() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/451251147034854661/Actions/Response",
    method: "GET"
  });
}
//邮箱发送状态
function emailstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/451248767941739781/Data/Selector",
    method: "GET"
  });
}
//
function receivingstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/450519495849542917/Data/Selector",
    method: "GET"
  });
}
//
function typesof() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/450888253378135301/Data/Selector",
    method: "GET"
  });
}

//人员
function personnel() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/450892238176650501/Actions/Response",
    method: "GET"
  });
}
//库房
function storeroom() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283123849300542725/Actions/Response",
    method: "GET"
  });
}
//入库方式
function warehousingmethod() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/450821188696933637/Data/Selector",
    method: "GET"
  });
}
//入库类型
function receipttype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/450517129016378629/Data/Selector",
    method: "GET"
  });
}
//上架状态
function listingstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/450818968513414405/Data/Selector",
    method: "GET"
  });
}
//全部人员
function personnelall() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/450892238176650501/Actions/Response",
    method: "GET"
  });
}

//之前项目里的
//在制品履历四种交易记录
function Transaction() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/370538247790527749/Actions/Response",
    method: "GET"
  });
}

//物料标识
function Logos() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/447914712475108613/Data/Selector",
    method: "GET"
  });
}
//物料单位
function FUnits() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/447917783770989829/Data/Selector",
    method: "GET"
  });
}
//批号型态
function Batchtypes() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/348310678924166405/Data/Selector",
    method: "GET"
  });
}
//库区状态
function warehousestatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/446543701557118213/Data/Selector",
    method: "GET"
  });
}
//库区类型
function storagearea() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/446544592091743493/Data/Selector",
    method: "GET"
  });
}
//工单型态
function ordertype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/348300224730498309/Data/Selector",
    method: "GET"
  });
}
function rackclassifications() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/341362447547892997/Actions/Response",
    method: "GET"
  });
}
//料及分类
function rackclassification() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/342800121857049861/Actions/Response",
    method: "GET"
  });
}
//盘点类型
function getInventoryState() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/285622366619305221/Data/Selector",
    method: "GET"
  });
}
//工序
function procedure() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281647222548858117/Actions/Response",
    method: "GET"
  });
}
//设备
function equipment() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281647050930521349/Actions/Response",
    method: "GET"
  });
}
function materiall() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281648199981073669/Actions/Response",
    method: "GET"
  });
}
//配件列表
function accessories() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/341370812323857669/Actions/Response",
    method: "GET"
  });
}
//保养单状态(字典)
function Maintenances() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/341419218857624837/Data/Selector",
    method: "GET"
  });
}
//维修单状态(字典)
function maintenancestatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/340276590195770629/Data/Selector",
    method: "GET"
  });
}
//检验类型
function Inspectiontype() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/337756857122686213/Actions/Response",
    method: "GET"
  });
}
//不良代码类型
function badcodetype() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/337107643606762757/Actions/Response",
    method: "GET"
  });
}
//厂商
function manufacturer() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/337073163454121221/Actions/Response",
    method: "GET"
  });
}
//料架种类
function materialrack() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/337070759178405125/Actions/Response",
    method: "GET"
  });
}
//规格
function specifications() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/336733932722586885/Actions/Response",
    method: "GET"
  });
}
//型态
function formForm() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/336734528720602373/Actions/Response",
    method: "GET"
  });
}
//分类
function classification() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/336734685755344133/Actions/Response",
    method: "GET"
  });
}
//设备状态类别
function equipmentstatus() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/336362891663901957/Actions/Response",
    method: "GET"
  });
}
//仓位
function cangwei() {
  return (0, _request.default)({
    url: "/api/MES/PublicData/GetStoresite",
    method: "GET"
  });
}
//组别
function classgroup() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/335267456572458245/Actions/Response",
    method: "GET"
  });
}
//执行规格
function zhixing() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/288900150779184389/Actions/Response",
    method: "GET"
  });
}
function kekuwei() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283123496282752261/Actions/Response",
    method: "GET"
  });
}

//维修状态
function Maintenancestatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/311039890684904709/Data/Selector",
    method: "GET"
  });
}
//点检状态
function Routinecheckstatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/311046466237891845/Data/Selector",
    method: "GET"
  });
}
//产品版本
function productversion() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/306313346347435269/Data/Selector",
    method: "GET"
  });
}
//研磨条件
function yanmo() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/304510581929411845/Data/Selector",
    method: "GET"
  });
}
//产品类型
function cpleixin() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/287368809113715973/Data/Selector",
    method: "GET"
  });
}
//中板代码
function Medium() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/292073701766071557/Data/Selector",
    method: "GET"
  });
}
function kuwei() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288902469180720389/Data/Selector",
    method: "GET"
  });
}
//工单型态说明
function Workordertype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288533801049523461/Data/Selector",
    method: "GET"
  });
}
//批号型态分类
function Batchtype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288533491765740805/Data/Selector",
    method: "GET"
  });
}
//箱号管理
function Boxnumber() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288446704074622213/Data/Selector",
    method: "GET"
  });
}
// 版式
function formatkey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/288465594863322373/Actions/Response",
    method: "GET"
  });
}
// 客户代码
function Customercode() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282384941528909061/Actions/Response",
    method: "GET"
  });
}
// 站别
function getStepSelector() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281647222548858117/Actions/Response",
    method: "GET"
  });
}
//测试厂别
function Factorytype() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282373555901957381/Actions/Response",
    method: "GET"
  });
}
//测试部门
function department() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/288574385063724293/Actions/Response",
    method: "GET"
  });
}
//厂别
function getFactory() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282373555901957381/Actions/Response",
    method: "GET"
  });
}
//厂别类型
function getFactoryType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283881514037413125/Data/Selector",
    method: "GET"
  });
}
//厂商类型
function getVendorType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283098698710254853/Data/Selector",
    method: "GET"
  });
}

//线别
function getLine() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281646835091637509/Actions/Response",
    method: "GET"
  });
}
//产品规格
function getItemFgg() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/292892562383963397/Actions/Response",
    method: "GET"
  });
}
//产品
function getItemFg() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281648199981073669/Actions/Response",
    method: "GET"
  });
}
var getStrItemFg = exports.getStrItemFg = "281648199981073669";
//产品批号
function getEntityItem() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281650543607153925/Actions/Response",
    method: "GET"
  });
}
var getStrEntityItem = exports.getStrEntityItem = "281650543607153925";
//原料
function getItemMtl() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281648069823431941/Actions/Response",
    method: "GET"
  });
}
var getStrItemMtl = exports.getStrItemMtl = "281648069823431941";

//上级物料群组
function getparentNameMtl() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283884642434548997/Actions/Response",
    method: "GET"
  });
}

//物料类型(ITEM_TYPE)
function getItemType() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282396251406730501/Actions/Response",
    method: "GET"
  });
}
//物料群组(ITEM_GROUP_KEY)
function getItemGroup() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282386543476212997/Actions/Response",
    method: "GET"
  });
}

//供应商
function getVender() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282383319197287685/Actions/Response",
    method: "GET"
  });
}
//客户
function getCustomer() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282384941528909061/Actions/Response",
    method: "GET"
  });
}
var getStrCustomer = exports.getStrCustomer = "282384941528909061";
//人员 最后操作人
function getUser() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282387584821232901/Actions/Response",
    method: "GET"
  });
}
//画面输入模式
function getAssyMode() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/282401076378862853/Data/Selector",
    method: "GET"
  });
}
//用料记录方式
function getMtlControl() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/282400983034627333/Data/Selector",
    method: "GET"
  });
}
//自定义使用分类
function getCustItemType() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282401755034027269/Actions/Response",
    method: "GET"
  });
}
//生产标签
function getWipLabel() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282402527666767109/Actions/Response",
    method: "GET"
  });
}
//外箱模板
function getRunCardTemp() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282403321975670021/Actions/Response",
    method: "GET"
  });
}
//工单
function getWoKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283145801880831237/Actions/Response",
    method: "GET"
  });
}
var getStrWoKey = exports.getStrWoKey = "283145801880831237";
//订单
function getOrderKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/284225660384183557/Actions/Response",
    method: "GET"
  });
}
var getStrOrderKey = exports.getStrOrderKey = "284225660384183557";
//工单状态
function getWoStatus() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/282413147980039429/Actions/Response",
    method: "GET"
  });
}
//规则类型
function getRuleType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283018719733482757/Data/Selector",
    method: "GET"
  });
}
//规则格式
function getRuleFormat() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283019171149645061/Data/Selector",
    method: "GET"
  });
}
//站点
function getStepKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283025261056754949/Actions/Response",
    method: "GET"
  });
}
//站点类型
function getStepType() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283073534459118853/Actions/Response",
    method: "GET"
  });
}
//车间
function getWorkShop() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/288194861683705093/Actions/Response",
    method: "GET"
  });
}
//途程
function getFlowKey() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/281647387821212933/Data/Selector",
    method: "GET"
  });
}

//途程数据接口
function getFlowKeyDataInterface() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281647387821212933/Actions/Response",
    method: "GET"
  });
}
//途程类别
function getFlowType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283076940791809285/Data/Selector",
    method: "GET"
  });
}
//库房
function getStoreRoom() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283123849300542725/Actions/Response",
    method: "GET"
  });
}
//库位
function getStoreSite() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283123496282752261/Actions/Response",
    method: "GET"
  });
}
//设备
function getEqpKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281647050930521349/Actions/Response",
    method: "GET"
  });
}
var getStrEqpKey = exports.getStrEqpKey = "281647050930521349";
//计量单位
function getUnitKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283129045690877189/Actions/Response",
    method: "GET"
  });
}
//WMS物料类别
function getWmsItemType() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/283128673723221253/Actions/Response",
    method: "GET"
  });
}

//班别
function getshiftKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/281646619252753669/Actions/Response",
    method: "GET"
  });
}
//出入库状态
function getStatus() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283142683453555973/Data/Selector",
    method: "GET"
  });
}
//入库类型
function getInType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283142962920031493/Data/Selector",
    method: "GET"
  });
}
//区域名称
function getAreaName() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/453720106694870277/Data/Selector",
    method: "GET"
  });
}
//叉车任务类型
function getForkliftTaskType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/453723461022385413/Data/Selector",
    method: "GET"
  });
}
//出库类型
function getOutType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/283143056390096133/Data/Selector",
    method: "GET"
  });
}

//设备群组
function getEquipmentGroup() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288454815065834757/Data/Selector",
    method: "GET"
  });
}

//设备状态变更代码
function getEquipmentStatusChangeCode() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288454672077817093/Data/Selector",
    method: "GET"
  });
}

//设备属性
function getEquipmentProperties() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288454432444646661/Data/Selector",
    method: "GET"
  });
}

//上级设备名称
function getNameOfSuperiorEquipment() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288454209244759301/Data/Selector",
    method: "GET"
  });
}

//设备类型
function getEquipmentType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288453395981796613/Data/Selector",
    method: "GET"
  });
}

//设备代码
function getEquipmentCode() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/288452927146689797/Data/Selector",
    method: "GET"
  });
}
//区域
function getDataInterface() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/288194861683705093/Actions/Response",
    method: "GET"
  });
}

// 客户端菜单
function getStepMenu() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/349445667627730181/Data/Selector",
    method: "GET"
  });
}

//设备群组
function getEquipmentGroupOwner() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/292165685532951813/Actions/Response",
    method: "GET"
  });
}
//机种
function getTypeOfMachine() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/292482402209498373/Actions/Response",
    method: "GET"
  });
}
//反报废原因
function getUnScrapKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/292819494055707909/Actions/Response",
    method: "GET"
  });
}
//Hold原因
function getHoldKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/293268613257757957/Actions/Response",
    method: "GET"
  });
}
//取消Hold原因
function getHoldRelKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/293903949444941061/Actions/Response",
    method: "GET"
  });
}
//Hold处理方式
function getHoldHandleKey() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/293274012258141445/Data/Selector",
    method: "GET"
  });
}
//Hold处理方式
function getFileName() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/299332184211195141/Data/Selector",
    method: "GET"
  });
}

//模板文件类型
function getTempType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/299787654591939845/Data/Selector",
    method: "GET"
  });
}
//模板文件
function getTempKey() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/299822444342936837/Actions/Response",
    method: "GET"
  });
}
//保养
//保养频率
function getOsiTimePlan() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/301951501155173637/Actions/Response",
    method: "GET"
  });
}
//保养方式
function getPmKind() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/289558868097238277/Data/Selector",
    method: "GET"
  });
}
//分组
function getGroup() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/461395561795290373/Data/Selector",
    method: "GET"
  });
}
//物料分类
function getMaterial() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/449000329124513029/Actions/Response",
    method: "GET"
  });
}
//物料子分类
function getSonMaterial() {
  return (0, _request.default)({
    url: "/api/system/DataInterface/449465070045365509/Actions/Response",
    method: "GET"
  });
}

//出入库类型
function getOutInStockType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/462057514532340997/Data/Selector",
    method: "GET"
  });
}
//出库单据类型
function getoutdocumenttype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/460654437992498437/Data/Selector",
    method: "GET"
  });
}
//入库单据类型
function getindocumenttype() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/450517129016378629/Data/Selector",
    method: "GET"
  });
}
//库房结构标识
function getwarehouseorganization() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/462465252630463749/Data/Selector",
    method: "GET"
  });
}
//承运商类型
function getcorporatename() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/572232453742134533/Data/Selector",
    method: "GET"
  });
}
//货物类型
function getgoods() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/572269117860480261/Data/Selector",
    method: "GET"
  });
}

//调账记录 记录类型
function aRecodeType() {
  return (0, _request.default)({
    url: "/api/system/DictionaryData/RecordType/Data/Selector",
    method: "GET"
  });
}